import { gql } from '@apollo/client';

export default class ReportMutation {
    static LOG_SALES_TAX_REPORT_RUNS = gql`
        mutation logSalesTaxReportRuns($input: LogRunInput!) {
            logSalesTaxReportRuns(input: $input)
        }
    `;
}
